// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#auth[data-v-f9bd480c] {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: var(--principal-azul);\r\n  max-width: unset;\n}\r\n", ""]);
// Exports
module.exports = exports;
